import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Calendar, Clock } from "lucide-react";

interface OneOnOneScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedMember?: any;
  onSchedule?: (data: any) => void;
}

const OneOnOneScheduleModal: React.FC<OneOnOneScheduleModalProps> = ({
  isOpen,
  onClose,
  selectedMember,
  onSchedule,
}) => {
  const handleSchedule = () => {
    if (onSchedule && selectedMember) {
      onSchedule({
        id: `session-${Date.now()}`,
        title: `1-on-1 with ${selectedMember.firstName || selectedMember.email}`,
        date: new Date(),
        startTime: "10:00",
        duration: "30",
        participant: selectedMember,
        isRescheduled: false,
      });
    }
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg font-semibold">
            <Calendar className="h-4 w-4" />
            Schedule 1:1 (Preview)
          </DialogTitle>
          <DialogDescription>
            We're building a richer 1-on-1 scheduling experience. In the meantime, we'll note your interest.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Member: <span className="font-medium text-foreground">{selectedMember?.firstName} {selectedMember?.lastName}</span>
          </p>
          <p className="flex items-center gap-2 text-sm text-muted-foreground">
            <Clock className="h-4 w-4" />
            Suggested duration: 30 minutes
          </p>
          <Button onClick={handleSchedule} className="w-full">
            Notify me when scheduling is available
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { OneOnOneScheduleModal };
